import {useContext} from "react";
import {observer} from "mobx-react";
import {YStack} from "@chayka/ui";
import {BackButton} from "@/components/layout";
import {SignUpStateContext} from "./state";
import {useNavigate} from "react-router-dom";

export const SignUpHeader: React.FC = observer(() => {
  const {goToPrevious, step} = useContext(SignUpStateContext);
  const navigate = useNavigate();

  return (
    <div className="py-4 flex justify-center items-center w-full sticky top-0 bg-background z-10">
      <YStack className="gap-3 justify-center items-center">
        <h1 className="font-bold text-xl">Регистрация</h1>
        <div className="w-40 h-1 overflow-hidden rounded-full bg-indicator" role="progressbar">
          <div
            className={`h-full rounded-full bg-blackout transition-all duration-300 ease-out ${step === "first" ? "w-1/2" : "w-full"}`}
          />
        </div>
      </YStack>
      <div className="absolute left-0">
        <BackButton onClick={step === "second" ? goToPrevious : () => navigate(-1)} />
      </div>
    </div>
  );
});
